module.exports = __webpack_public_path__ + "static/1-acbfa89e920a8dde895df60593cbfeb4.png";